import React, { useState } from 'react';
import Box from 'core/ui/Box';
import { ButtonPrimary } from 'core/ui/Button';
import Paper from 'core/ui/Paper';
import Typography from 'core/ui/Typography';
import { useTranslation } from 'react-i18next';
import LoaderSm from 'core/ui/LoaderSm';
import ListHeats from './List';
import Modal from './Modal';
import useHeats from './useHeats';

const WorkoutHeats = ({ workout, isCoach, buttonColor, fontColor, loading }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const {
    competition,
    heats,
    heatsUsers,
    loadingHeats,
    loadingLeaderboard,
    leaderboard,
  } = useHeats({
    workout,
  });
  return (
    <>
      {!!open && (
        <Modal
          workout={workout}
          open={open}
          close={() => setOpen(false)}
          buttonColor={buttonColor}
          fontColor={fontColor}
        />
      )}

      <Paper elevation={2} mb={3} className="paper-rounded opacity-80" p={3}>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>
            <Typography mb={3} variant="h5" color="secondary">
              {t('workout.heats').toUpperCase()}
            </Typography>
            <LoaderSm loading={loadingHeats || loadingLeaderboard} />
          </Box>
          {isCoach && (
            <ButtonPrimary buttonColor={buttonColor} onClick={() => setOpen(true)}>
              {t('button.editHeats').toUpperCase()}
            </ButtonPrimary>
          )}
        </Box>
        {loading && (
          <Box display="flex" justifyContent="center">
            <LoaderSm loading={loading} />
          </Box>
        )}
        {!open && !loadingHeats && !loadingLeaderboard && leaderboard && (
          <Box mt={3}>
            <ListHeats
              workout={workout}
              compUsers={competition && competition.users}
              leaderboard={leaderboard}
              heats={heats}
              heatsUsers={heatsUsers}
              dropable={false}
            />
          </Box>
        )}
      </Paper>
    </>
  );
};

export default WorkoutHeats;
